// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__2AC6H","Open":"Auth_Open__2H6ei","Close":"Auth_Close__1o3Ge","Brand":"Auth_Brand__Ki_MA","ErrorBox":"Auth_ErrorBox__3tNe5","SuccesBox":"Auth_SuccesBox__2oeOa"};